import { render, staticRenderFns } from "./OrderSettlement.vue?vue&type=template&id=a924fb28&scoped=true&"
import script from "./OrderSettlement.vue?vue&type=script&lang=js&"
export * from "./OrderSettlement.vue?vue&type=script&lang=js&"
import style0 from "./OrderSettlement.vue?vue&type=style&index=0&id=a924fb28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a924fb28",
  null
  
)

export default component.exports